// extracted by extract-css-chunks-webpack-plugin
module.exports = {"result-list":"mvJUgP9hAicGMb47n9XjCQ==","resultList":"mvJUgP9hAicGMb47n9XjCQ==","result-network":"sYMX5wWOO-ETr5Dy+Q2DQA==","resultNetwork":"sYMX5wWOO-ETr5Dy+Q2DQA=="};